const pseudoComponents_Brent = [
  { name: "PC01", Tb: 86.7, MW: 84.3, Tc: 417.55, Pc: 45.00, omega: -0.013, SG: 0.543 },
  {
    name: "PC02",
    Tb: 100.0,
    MW: 95.0,
    Tc: 438.65,
    Pc: 44.21,
    omega: 0.000,
    SG: 0.550,
  },
  {
    name: "PC03",
    Tb: 113.3,
    MW: 105.7,
    Tc: 459.35,
    Pc: 43.41,
    omega: 0.013,
    SG: 0.557,
  },
  {
    name: "PC04",
    Tb: 126.7,
    MW: 116.3,
    Tc: 479.85,
    Pc: 42.62,
    omega: 0.027,
    SG: 0.563,
  },
  {
    name: "PC05",
    Tb: 140.0,
    MW: 127.0,
    Tc: 500.05,
    Pc: 41.83,
    omega: 0.040,
    SG: 0.570,
  },
  {
    name: "PC06",
    Tb: 146.7,
    MW: 132.3,
    Tc: 510.05,
    Pc: 41.03,
    omega: 0.047,
    SG: 0.573,
  },
  {
    name: "PC07",
    Tb: 153.3,
    MW: 137.7,
    Tc: 520.05,
    Pc: 40.24,
    omega: 0.053,
    SG: 0.577,
  },
  {
    name: "PC08",
    Tb: 160.0,
    MW: 143.0,
    Tc: 529.85,
    Pc: 39.45,
    omega: 0.060,
    SG: 0.580,
  },
  {
    name: "PC09",
    Tb: 173.3,
    MW: 153.7,
    Tc: 549.45,
    Pc: 38.66,
    omega: 0.073,
    SG: 0.587,
  },
  {
    name: "PC10",
    Tb: 186.7,
    MW: 164.3,
    Tc: 568.75,
    Pc: 37.86,
    omega: 0.087,
    SG: 0.593,
  },
  {
    name: "PC11",
    Tb: 200.0,
    MW: 175.0,
    Tc: 587.75,
    Pc: 37.07,
    omega: 0.100,
    SG: 0.600,
  },
  {
    name: "PC12",
    Tb: 200.0,
    MW: 175.0,
    Tc: 587.75,
    Pc: 36.28,
    omega: 0.100,
    SG: 0.600,
  },
  {
    name: "PC13",
    Tb: 210.0,
    MW: 183.0,
    Tc: 601.85,
    Pc: 35.48,
    omega: 0.110,
    SG: 0.607,
  },
  {
    name: "PC14",
    Tb: 213.3,
    MW: 185.7,
    Tc: 606.55,
    Pc: 34.69,
    omega: 0.113,
    SG: 0.607,
  },
  {
    name: "PC15",
    Tb: 220.0,
    MW: 191.0,
    Tc: 615.75,
    Pc: 33.90,
    omega: 0.120,
    SG: 0.615,
  },
  {
    name: "PC16",
    Tb: 226.7,
    MW: 196.3,
    Tc: 625.05,
    Pc: 33.10,
    omega: 0.127,
    SG: 0.615,
  },
  {
    name: "PC17",
    Tb: 240.0,
    MW: 207.0,
    Tc: 643.35,
    Pc: 32.31,
    omega: 0.140,
    SG: 0.620,
  },
  {
    name: "PC18",
    Tb: 253.3,
    MW: 217.7,
    Tc: 661.35,
    Pc: 31.52,
    omega: 0.153,
    SG: 0.627,
  },
  {
    name: "PC19",
    Tb: 273.3,
    MW: 233.7,
    Tc: 688.05,
    Pc: 30.72,
    omega: 0.173,
    SG: 0.637,
  },
  {
    name: "PC20",
    Tb: 300.0,
    MW: 255.0,
    Tc: 722.75,
    Pc: 29.93,
    omega: 0.200,
    SG: 0.650,
  },
  {
    name: "PC21",
    Tb: 313.3,
    MW: 265.7,
    Tc: 739.85,
    Pc: 29.14,
    omega: 0.213,
    SG: 0.657,
  },
  {
    name: "PC22",
    Tb: 326.7,
    MW: 276.3,
    Tc: 756.65,
    Pc: 28.34,
    omega: 0.227,
    SG: 0.663,
  },
  {
    name: "PC23",
    Tb: 340.0,
    MW: 287.0,
    Tc: 773.35,
    Pc: 27.55,
    omega: 0.240,
    SG: 0.670,
  },
  {
    name: "PC24",
    Tb: 366.7,
    MW: 308.3,
    Tc: 805.95,
    Pc: 26.76,
    omega: 0.267,
    SG: 0.683,
  },
  {
    name: "PC25",
    Tb: 391.7,
    MW: 328.3,
    Tc: 835.85,
    Pc: 25.97,
    omega: 0.292,
    SG: 0.696,
  },
  {
    name: "PC26",
    Tb: 415.0,
    MW: 347.0,
    Tc: 863.15,
    Pc: 25.17,
    omega: 0.315,
    SG: 0.708,
  },
  {
    name: "PC27",
    Tb: 438.3,
    MW: 365.7,
    Tc: 889.95,
    Pc: 24.38,
    omega: 0.338,
    SG: 0.719,
  },
  {
    name: "PC28",
    Tb: 470.0,
    MW: 391.0,
    Tc: 925.35,
    Pc: 23.59,
    omega: 0.370,
    SG: 0.735,
  },
  {
    name: "PC29",
    Tb: 510.0,
    MW: 423.0,
    Tc: 968.65,
    Pc: 22.79,
    omega: 0.410,
    SG: 0.755,
  },
  {
    name: "PC30",
    Tb: 550.0,
    MW: 455.0,
    Tc: 1010.55,
    Pc: 22.00,
    omega: 0.450,
    SG: 0.775,
  },
];

export default pseudoComponents_Brent;
